export const SCRIPT_PLATFORMS = ["meta", "shorts", "in_stream"] as const;

export type ScriptPlatform = (typeof SCRIPT_PLATFORMS)[number];

export type ScriptPlatformFilter = "all" | ScriptPlatform;

export const SCRIPT_PLATFORM_LABELS: Record<ScriptPlatform, string> = {
  meta: "Meta",
  shorts: "YT Shorts",
  in_stream: "YT In-Stream",
};

/** Absent and any unrecognized stored value display as Meta. */
export function scriptPlatformFromFormat(format: string | null | undefined): ScriptPlatform {
  if (format === "shorts_9_16") return "shorts";
  if (format === "in_stream_16_9") return "in_stream";
  return "meta";
}

export function matchesScriptPlatform(
  format: string | null | undefined,
  filter: ScriptPlatformFilter,
): boolean {
  if (filter === "all") return true;
  return scriptPlatformFromFormat(format) === filter;
}
